import { render, staticRenderFns } from "./SimpleUpload.vue?vue&type=template&id=c77d50f8&scoped=true&"
import script from "./SimpleUpload.vue?vue&type=script&lang=js&"
export * from "./SimpleUpload.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUpload.vue?vue&type=style&index=0&id=c77d50f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77d50f8",
  null
  
)

export default component.exports